var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unselect",on:{"click":_vm.clickShare}},[_c('img',{attrs:{"src":"/static/icon/ic_facebook_circle.svg"}}),_c('div',{staticClass:"size-12 sub1 text-center margin-top-8"},[_vm._v("페이스북")])])}
var staticRenderFns = []

export { render, staticRenderFns }